import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    padding: 20px 20%;
    position: relative;
    width: 100%;
`

const Gif = styled.img`
    display: block;
    height: 100%;
    max-width: 400px;
    object-fit: contain;
    position: relative;
    width: 100%;
`

const Video404Oops = () => (
    <Container>
        <Gif src="/static/img/embeds/oops.gif" alt="" />
    </Container>
)

export default Video404Oops
